/* Living.Fit v3 sitewide Baymard fixes. Loaded by snippets/lf-v3-assets.liquid (guarded against double-init). */
(function () {
  if (window.__lfSite) return; window.__lfSite = 1;
  var root = document.documentElement;

  /* #1591: one polite live region for dynamic updates (cart count) */
  var live;
  function say(msg) {
    if (!live) { live = document.createElement('div'); live.className = 'lf-live'; live.setAttribute('role', 'status'); live.setAttribute('aria-live', 'polite'); document.body.appendChild(live); }
    live.textContent = ''; setTimeout(function () { live.textContent = msg; }, 60);
  }
  window.lfAnnounce = say;

  /* #928: show a loading bar while cart requests are in flight; announce the new cart count */
  if (window.fetch && !window.__lfFetchWrapped) {
    window.__lfFetchWrapped = 1;
    var n = 0, of = window.fetch;
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var isCart = /\/cart(\/(add|change|update|clear))?(\.js)?(\?|$)/.test(url) && init && init.method && init.method.toUpperCase() === 'POST';
      if (!isCart) return of.apply(this, arguments);
      n++; root.classList.add('lf-busy');
      var p = of.apply(this, arguments);
      var done = function () { n = Math.max(0, n - 1); if (!n) root.classList.remove('lf-busy'); };
      p.then(function (r) {
        done();
        if (r && r.ok) setTimeout(function () {
          of('/cart.js', { credentials: 'same-origin' }).then(function (x) { return x.json(); }).then(function (c) {
            var count = (c.items || []).reduce(function (n, item) { var rolls = Number(item.properties && item.properties['Roll(s)']); return n + (Number.isFinite(rolls) && rolls > 0 ? rolls : Number(item.quantity) || 0); }, 0);
            say('Cart updated. ' + count + (count === 1 ? ' item' : ' items') + ' in your cart.');
          }).catch(function () {});
        }, 250);
      }, done);
      return p;
    };
  }

  function boot() {
    /* #948: no autocorrect / auto-capitalize on email, name and address fields */
    var sel = 'input[type=email],input[name*=email i],input[autocomplete*=email],input[autocomplete*=name],input[name*=name i],input[autocomplete*=address],input[name*=address i],input[name*=zip i],input[autocomplete=postal-code]';
    var fix = function (scope) { (scope || document).querySelectorAll(sel).forEach(function (i) { if (i.type === 'hidden') return; i.setAttribute('autocorrect', 'off'); i.setAttribute('spellcheck', 'false'); if (!/name/i.test(i.name + i.autocomplete) || /email/i.test(i.name + i.type)) i.setAttribute('autocapitalize', 'off'); }); };
    fix();
    new MutationObserver(function (ms) { ms.forEach(function (m) { m.addedNodes.forEach(function (x) { if (x.nodeType === 1) fix(x); }); }); }).observe(document.body, { childList: true, subtree: true });

    /* #255: don't link to the page the shopper is on (header nav, footer, breadcrumbs) */
    var here = location.pathname.replace(/\/$/, '').toLowerCase() || '/';
    if (here !== '/' && !location.search) {
      document.querySelectorAll('.lfh__nav a[href], .lfh__drawer a[href], .lff a[href], .breadcrumbs a[href], .lf404__bc a[href], .lfpg__bc a[href]').forEach(function (a) {
        if (a.hasAttribute('aria-haspopup') || a.hasAttribute('data-lfh-dd')) return;
        var u; try { u = new URL(a.href, location.href); } catch (e) { return; }
        if (u.hash || u.search || u.host.replace(/^www\./, '') !== location.host.replace(/^www\./, '')) return;
        if ((u.pathname.replace(/\/$/, '').toLowerCase() || '/') !== here) return;
        var s = document.createElement('span'); s.className = (a.className ? a.className + ' ' : '') + 'lf-here'; s.setAttribute('aria-current', 'page'); s.innerHTML = a.innerHTML; a.replaceWith(s);
      });
    }

    /* Policy pages: "On this page" list from the page's own h2 headings (Baymard #3432 scannability) */
    var toc = document.querySelector('[data-lfpg-toc]'), body = document.querySelector('.lfpg .rte');
    if (toc && body) {
      var hs = body.querySelectorAll('h2'); if (hs.length < 3) { toc.hidden = true; return; }
      var ul = toc.querySelector('ul');
      hs.forEach(function (h, i) { if (!h.id) h.id = 'lfpg-' + i; var li = document.createElement('li'), a = document.createElement('a'); a.href = '#' + h.id; a.textContent = h.textContent.trim(); li.appendChild(a); ul.appendChild(li); });
      toc.hidden = false;
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
})();
